import Projects from "./Projects.container";

export default Projects;
